import { observer } from "mobx-react";
import RmaShipmentStore from "../../../../stores/rma-shipment-store";
import '../../rma-page-shipments-card.scss';
import RmaPageStore from "../../../../stores/rma-page-store";
import DropOffLocationGridWithIntegration from "./drop-off-location-with-integration";
import DropOffLocationGridWithoutIntegration from "./drop-off-location-grid-without-integration";
import { RMA_STATUS, SHIPMENT_STATUS_ENUM } from "../../../../rma-types";
import { DROP_OFF_LOCATION } from "../../../../../../return-methods/constants";
import useDashboardTranslation from "../../../../../../../dashboard-translation/hooks/dashboard-translation-hook";

interface IProps {
    shipment: RmaShipmentStore;
    rmaPageStore: RmaPageStore;
};

const ShipWithToDropOffLocation: React.FC<IProps> = observer(({ shipment, rmaPageStore }) => {
    const dropOffLocation = rmaPageStore.dropOffLocationAddress();
    const { getTranslation } = useDashboardTranslation();
    const pageScope = 'dashboard-returns-rma-card';


    const hasIntegration = dropOffLocation?.source === DROP_OFF_LOCATION.DROPOFF_INTEGRATION;

    const rmaStatusToShipmentStatusMap: { [key: string]: SHIPMENT_STATUS_ENUM | null } = {
        [RMA_STATUS.APPROVED]: SHIPMENT_STATUS_ENUM.PENDING_SHIPMENT,
        [RMA_STATUS.RECEIVED]: SHIPMENT_STATUS_ENUM.RECEIVED,
    } as const;
    
    const isStatusDisplayed = !!(
        dropOffLocation?.source === DROP_OFF_LOCATION.DROPOFF_INTEGRATION
        || (rmaPageStore.status && rmaStatusToShipmentStatusMap.hasOwnProperty(rmaPageStore.status))
    );

    let location;
    switch (dropOffLocation?.source) {
        case DROP_OFF_LOCATION.CUSTOM_ADRESS:
            location = getTranslation("SHIPMENT_CUSTOM_ADDRESS", pageScope);
            break;
        case DROP_OFF_LOCATION.DYNAMIC_ADDRESS:
            location = dropOffLocation.name;
            break;
        case DROP_OFF_LOCATION.DROPOFF_INTEGRATION:
            location = '';
            break;
        default:
            location = '';
    }

    if (shipment.isBagShipment) {
        return null;
    }

    return hasIntegration
        ? shipment.isOutboundShipment
            ?
                <div className="shipping-of-type-outbound-shipment">
                    <DropOffLocationGridWithIntegration isStatusDisplayed={isStatusDisplayed} shipment={shipment} rmaPageStore={rmaPageStore} />
                </div>
            :   <DropOffLocationGridWithIntegration isStatusDisplayed={isStatusDisplayed} shipment={shipment} rmaPageStore={rmaPageStore} />
        : <DropOffLocationGridWithoutIntegration isStatusDisplayed={isStatusDisplayed} location={location} shipment={shipment} rmaPageStore={rmaPageStore} />;
});
export default ShipWithToDropOffLocation;